import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { AppShell } from "./AppShell";
import { useAuth } from "./providers/AuthProvider";
import { LoginPage } from "../features/auth/LoginPage";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { DailyEntryPage } from "../features/daily-entry/DailyEntryPage";
import { SettingsPage } from "../features/settings/SettingsPage";
import { WorkersPage } from "../features/workers/WorkersPage";
import { MasterDataPage } from "../features/master-data/MasterDataPage";
import { AnalyticsPage } from "../features/analytics/AnalyticsPage";
import { ReportsPage } from "../features/reports/ReportsPage";
import { ReportDetailPage } from "../features/reports/ReportDetailPage";

function RequireAuth({ children }: { children: React.ReactElement }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// `/izvestaji` is a SINGLE route that branches on the `?type=` query param
// (task spec §10 prefers query-param state over a nested path segment) —
// two `<Route>`s both matching the same path is not valid in React Router,
// so this wrapper renders `ReportDetailPage` when `type` is present and
// falls back to the `ReportsPage` landing view otherwise.
function ReportsRouteSwitch() {
  const [searchParams] = useSearchParams();
  return searchParams.has("type") ? <ReportDetailPage /> : <ReportsPage />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/pregled" element={<DashboardPage />} />
        <Route path="/dnevni-unos" element={<DailyEntryPage />} />
        <Route path="/radnici" element={<WorkersPage />} />
        <Route path="/analitika" element={<AnalyticsPage />} />
        <Route path="/izvestaji" element={<ReportsRouteSwitch />} />
        <Route path="/sifarnici" element={<MasterDataPage />} />
        <Route path="/podesavanja" element={<SettingsPage />} />
        <Route path="/" element={<Navigate to="/pregled" replace />} />
      </Route>
    </Routes>
  );
}
